angular.module('picmonicng').component('referralStatsTable', {
  templateUrl: '/templates/app/components/referral-stats-table/referral-stats-table.html',
  bindings: {
    referrals: '<',
    isAdmin: '<',
  },
  controller: [
    '$filter',
    function ($filter) {
      var $ctrl = this;
      $ctrl.referralsLimit = $ctrl.isAdmin ? null : 5;
      $ctrl.statusPopover =
        '<div class="pls-font-size-12 text-left">' +
        '<div><strong class="nowrap">SENT</strong><br/><span class="nowrap">Referral link has been sent</span></div>' +
        '<div><strong class="nowrap">PICMONIC FREE</strong><br/><span class="nowrap">Referred user has created free account</span></div>' +
        '<div><strong>PICMONIC PREMIUM</strong><br/><span>Referred user has joined Picmonic Premium</span></div>' +
        '<div><strong>PICMONIC PREMIUM BEFORE 7/10/18</strong><br/><span>Referred user has joined Picmonic Premium before 7/10/18</span></div>' +
        '<div><strong>PICMONIC PREMIUM BEFORE 8/15/17</strong><br/><span>Referred user has joined Picmonic Premium before 8/15/17</span></div>' +
        '<div><strong>FIRST PURCHASE CREDIT BEFORE 8/15/17</strong><br/><span>A credit you received when you made your first purchase 8/15/17</span></div>' +
        '</div>';

      $ctrl.updateNextBonus = function (friends) {
        if (friends < 2) {
          $ctrl.nextBonus = 2 - friends;
        } else if (friends < 5) {
          $ctrl.nextBonus = 5 - friends;
        } else if (friends < 10) {
          $ctrl.nextBonus = 10 - friends;
        } else if (friends < 20) {
          $ctrl.nextBonus = 20 - friends;
        } else if (friends < 30) {
          $ctrl.nextBonus = 30 - friends;
        } else if (friends < 50) {
          $ctrl.nextBonus = 50 - friends;
        } else if (friends < 70) {
          $ctrl.nextBonus = 70 - friends;
        } else if (friends < 100) {
          $ctrl.nextBonus = 100 - friends;
        }
      };

      $ctrl.$onChanges = function (changes) {
        changes.referrals.currentValue &&
          changes.referrals.currentValue.$promise.then(function (value) {
            $ctrl.updateNextBonus(value.friends);
          });
      };

      $ctrl.getGiftCardStatus = function (referral) {
        if (referral.status != 'PICMONIC PREMIUM') {
          return 'Not Eligible';
        }
        if (referral.redeemable) {
          return 'Redeemable - $' + referral.redemption_value;
        }
        if (referral.redeemed_at) {
          return (
            'Redeemed at ' + $filter('date')(referral.redeemed_at * 1000, 'short') + ' -  $' + referral.redemption_value
          );
        }
        if (referral.date < 1559372399) {
          return 'Sent Previously';
        }
        if (referral.date + 86400 * 30 > Date.now() / 1000) {
          return 'Redeemable After ' + $filter('date')((referral.date + 86400 * 30) * 1000, 'short');
        } else {
          return 'Expired ' + $filter('date')((referral.date + 86400 * 90) * 1000, 'short');
        }
      };
    },
  ],
});
